module.exports = __webpack_public_path__ + "img/close-dark.259a2c7d.svg";